$(document).ready(function(){
var url1 = new URL(window.location.href);
var searchParams = url1.searchParams;
console.log(searchParams.get('client_id')+"searchparam");
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
var getc = getCookie('client_id');
var cdate = new Date();
var cday = cdate.getDay();
var cMonth = searchParams.get('date47[month]');  
var cyear = searchParams.get('date47[year]');
var crdate = searchParams.get('date47[day]');
var cHrs = searchParams.get('time51');

//var format = '&month='+cMonth+'&day='+cday+'&year='+cyear+'&time='+cHrs+':'+cMin;
  console.log("cday="+cday);
  if( cMonth != null && cyear != null && crdate != null && cHrs != null )
  {
    var format = '&date47[month]='+cMonth+'&date47[day]='+crdate+'&date47[year]='+cyear+'&time51='+cHrs;
  }
  else
  {
    var format = "";
  }
console.log(getc+format);  
console.log(getc)
var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');  
var result = url[0].includes("client_id");
  if ( searchParams.get('client_id') != null )
  {
    
  }
  if ( getc != undefined && getc != "" && getc != "null" && getc != null )
  {
    if ( getc == searchParams.get('client_id') )
    {
      $(".bundles-card-outter").each(function(){
      var getlink  = $(this).find(".secure-div").find("a").attr("href")
      console.log(getlink)
      $(this).find(".secure-div").find("a").attr("href",getlink+"?client_id="+getc+format);
    })
    }
    else
    {
      if (result == true)
    {
      setCookie('client_id', searchParams.get('client_id'), 2);
    }
      $(".bundles-card-outter").each(function(){
      var getlink  = $(this).find(".secure-div").find("a").attr("href")
      console.log(getlink)
      $(this).find(".secure-div").find("a").attr("href",getlink+"?client_id="+getc+format);
    })
    }
    
  }
  else
  {
    if (result == true)
  {
    setCookie('client_id', searchParams.get('client_id'), 2)
    $(".bundles-card-outter").each(function(){
      var getlink  = $(this).find(".secure-div").find("a").attr("href")
      console.log(getlink)
      $(this).find(".secure-div").find("a").attr("href",getlink+"?"+url+format);
    })
    
  }
  }
  
// Load the IFrame Player API code asynchronously.
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/player_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
// Replace the 'ytplayer' element with an <iframe> and
// YouTube player after the API code downloads.
var player;
function onYouTubePlayerAPIReady() {
    player = new YT.Player('ytplayer', {
        height: '480',
        width: '853',
        videoId: 'JW5meKfy3fY',
        playerVars: {
            'autoplay': 1,
            'showinfo': 0,
            'controls': 0
        }
    });
}
  
  console.log("working")
  $("li.tab-collage__item p").on("click", function(){
    var block_id = $(this).attr("data-block-id");    
    var vidType = $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").find("video-section").attr("data-type");
    console.log(vidType)
    if ( vidType == "vimeo" )
    {
      var url = $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").find("video-section[data-type='"+vidType+"'] iframe").attr("data-src");
      var newurl = $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").find("video-section[data-type='"+vidType+"'] iframe").attr("new-src");
      console.log(url)
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"'] video-section[data-type='"+vidType+"'] iframe").removeAttr("src");
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"'] video-section[data-type='"+vidType+"'] iframe").attr("src", url);
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").nextAll(".tab-collage__card ").find("video-section[data-type='"+vidType+"'] iframe").attr("src", newurl);
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").prevAll(".tab-collage__card ").find("video-section[data-type='"+vidType+"'] iframe").attr("src", newurl);
    }
    if ( vidType == "youtube" )
    {
    
      var url = $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").find("video-section[data-type='"+vidType+"'] iframe").attr("data-src");
      var newurl = $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").find("video-section[data-type='"+vidType+"'] iframe").attr("new-src");
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"'] video-section[data-type='"+vidType+"'] iframe").removeAttr("src");
      console.log(url)
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"'] video-section[data-type='"+vidType+"'] iframe").attr("src", url);
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").nextAll(".tab-collage__card ").find(" video-section[data-type='"+vidType+"']iframe").attr("src", newurl);
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").prevAll(".tab-collage__card ").find("video-section[data-type='"+vidType+"'] iframe").attr("src", newurl);
     
    }
    
    
  })
  var width = $(window).width();
    console.log(width)
    if ( width > 749 )
    {
      $("li.tab-collage__item p").on("mouseover", function(){
    var block_id = $(this).attr("data-block-id");    
    var vidType = $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").find("video-section").attr("data-type");
    console.log(vidType)
    if ( vidType == "vimeo" )
    {
      var url = $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").find("video-section[data-type='"+vidType+"'] iframe").attr("data-src");
      var newurl = $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").find("video-section[data-type='"+vidType+"'] iframe").attr("new-src");
      console.log(url)
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"'] video-section[data-type='"+vidType+"'] iframe").removeAttr("src");
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"'] video-section[data-type='"+vidType+"'] iframe").attr("src", url);
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").nextAll(".tab-collage__card ").find("video-section[data-type='"+vidType+"'] iframe").attr("src", newurl);
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").prevAll(".tab-collage__card ").find("video-section[data-type='"+vidType+"'] iframe").attr("src", newurl);
    }
    if ( vidType == "youtube" )
    {
    
      var url = $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").find("video-section[data-type='"+vidType+"'] iframe").attr("data-src");
      var newurl = $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").find("video-section[data-type='"+vidType+"'] iframe").attr("new-src");
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"'] video-section[data-type='"+vidType+"'] iframe").removeAttr("src");
      console.log(url)
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"'] video-section[data-type='"+vidType+"'] iframe").attr("src", url);
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").nextAll(".tab-collage__card ").find(" video-section[data-type='"+vidType+"']iframe").attr("src", newurl);
      $(this).parents(".page-width--full-width").find(".tab-collage__card[data-block-id='"+block_id+"']").prevAll(".tab-collage__card ").find("video-section[data-type='"+vidType+"'] iframe").attr("src", newurl);
     
    }
    
    
  })
    }
  
  //code start membership-plans section slider

  $('#bundles_slide').on('init', function(event, slick){
  if (slick.slideCount <= slick.options.slidesToShow) {
    $('#bundles_slide .slick-dots').hide();
    $('#bundles_slide').addClass('slider_not-enabled');
    } 
    else
  {
     $('#bundles_slide').removeClass('slider_not-enabled');
  }
  });

   $('#bundles_slide').on('init',function(){
    //$(".slick-current").prev().addClass('prevdiv');
   $(".slick-slide").removeClass('next-div');
   $(".slick-slide").removeClass('second_next-div');
   $(".slick-current").next().addClass('next-div');
   $(".slick-current").next().next().addClass('second_next-div');
});
 
  $('#bundles_slide').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    useTransform:true,
    draggable:true,
    dots: true,
    arrows: false,
     adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1199.99,
        settings: {
        slidesToScroll: 1,
          slidesToShow: 3,
          centerMode:true
        }
      },
      {
        breakpoint: 1024.99,
        settings: {
        slidesToScroll: 1,
          slidesToShow: 2,
          centerMode:true
        }
      },
      {
        breakpoint: 768,
        settings: {
        slidesToScroll: 1,
          slidesToShow: 1,
          centerMode:true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          centerMode:true
        }
      }
    ]
  }).on('afterChange',function(){
      //console.log($(".slick-current"));
      //$(".slick-current").prev().addClass('prevdiv');
     $(".slick-slide").removeClass('next-div');
     $(".slick-slide").removeClass('second_next-div');
     $(".slick-current").next().addClass('next-div');
     $(".slick-current").next().next().removeClass('next-div').addClass('second_next-div');

  });

  $('.top-slider-item-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024.99,
        settings: {
        slidesToScroll: 1,
          slidesToShow: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
        slidesToScroll: 1,
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  })

  $(".slick-slide:not(.slick-cloned) .top-slider-item-list").each(function(index){
      var h = $(this).height();
      console.log(h);
      var indx = parseInt(index)+1;
      var style = "--height"+indx;
      console.log(style);
      $(this).parents(".bundles-card-1").find(".main-for-bottom").css(style,h+'px');   
  });

  $(window).resize(function(){
    $(".slick-slide:not(.slick-cloned) .top-slider-item-list").each(function(index){
        var h = $(this).height();
        console.log(h);
        var indx = parseInt(index)+1;
        var style = "--height"+indx;
        console.log(style);
        $(this).parents(".bundles-card-1").find(".main-for-bottom").css(style,h+'px');   
    });
  });

  //Add to cart membership-plans product
    //  $(".bundles_slide-atc").on("click",function(e){
    //   e.preventDefault();
    //  $(this).addClass("loading");
    //   $.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data:$(this).parents("form").serialize(),
    //     dataType: 'json',
    //     success: function(response){
    //       setInterval(function() { 
    //        //console.log("Item Added Successfully to cart.");
    //         // $("body").addClass('mini-cart--open');
    //         // $('.cart-drawer-container').addClass('menu-opening');
    //         // $('.cart-drawer-container').attr("open", "open");
    //        $(".bundles_slide-atc").removeClass("loading");
    //        window.location.href = '/cart'; 
    //         }, 1000);
    //        }
    //   });
    // });
  $("span.price-details").on("click", function(){
    var id = $(this).attr('data-target');
    $(".modal-details[data-id='"+id+"']").show();
   // $(this).parents(".secure-div").find(".modal-details").show();
    $(this).parents(".bundles-card-outter").addClass("popup-active");
  })
  $("span.close-details").on("click", function(){
    $(this).parents(".modal-details").hide();
    $(this).parents(".bundles-card-outter").removeClass("popup-active");
  })
  $(".open-popup-div").on("click", function(){
    var id = $(this).attr('data-target');
    $(".modal-readmore[data-id='"+id+"']").show();
   // $(this).parents(".open-popup").find(".modal-readmore").show();
    $(this).parents(".bundles-card-outter").addClass("popup-active");
  })
  $("span.close-readmore").on("click", function(){
    $(this).parents(".modal-readmore").hide();
    $(this).parents(".bundles-card-outter").removeClass("popup-active");
  })
  // $(".bundles-card-outter").each(function(){
  //   var price = $(this).find(".popular-compare-price").text();
  //   if ( price != undefined && price != "" )
  //   {
  //     price = price.replace("$","");
  //     var main_price =  $(this).find(".popular-sale-price").text();
  //     main_price = main_price.replace("$","");
  //     main_price = main_price.replace("CA","");
  //     var disc = parseFloat(price) - parseFloat(main_price); 
  //     var discf = parseFloat(disc) / parseFloat(main_price) * 100;
  //     discf = discf.toFixed(2);
  //     console.log(discf);
  //     $(this).find(".save-discount").text("Save "+parseInt(discf)+"%");
  //   }
    
    
  // })
});
